module.exports = __webpack_public_path__ + "static/media/di-ung-thuoc.e11529ed.jpg";